// eslint-disable-next-line import/no-cycle
import Steps from './Steps.component';

export default Steps;